import React, { useState } from 'react';
import classNames from 'classnames';
import Participant from './Participant'
import ConfirmModal from './ParticipantConfirmModal';
import RenderProfile from '../../../_components/Profile';
import ParticipantSearch from '../List/Components/ParticipantSearch'

import { service } from '../../../_services/conversation.service';
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../_actions/alert.actions';
import { OverlayTrigger, Popover } from 'react-bootstrap';

export default function Participants({
  staffUser,
  licensedUser,
  participant,
  participants,
  conversation,
  shouldNotify,
  showParticipantNotified
}) {
  const dispatch = useDispatch();
  const [participantError, setParticipantError] = useState('')
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [gettingAttention, setGettingAttention] = useState(false)
  const [addingParticipant, setAddingParticipant] = useState(false)
  const [selectedParticipant, setSelectedParticipant] = useState(null)

  const handleCloseConfirm = () => {
    setShowConfirmModal(false)
    setParticipantError('')
    setSelectedParticipant(null)
  }

  const handleConfirmParticipant = (notifications) => {
    setAddingParticipant(true)
    service.addParticipant(conversation.id, selectedParticipant.userId, notifications)
      .then(() => {
        handleCloseConfirm()
        setAddingParticipant(false);
      })
      .catch((error) => {
        setParticipantError(
          error.response.status === 409 ?
            error.response.data.message : 'Could not add participant at this time. Please try again later.'
        )
        setAddingParticipant(false);
      });
  }

  const handleGetParticipantAttention = (participant) => {
    setGettingAttention(true)
    service.getParticipantAttention(conversation.id, participant.userId)
      .then(() => {
        showParticipantNotified(`${participant.firstName} ${participant.lastName}`)
      })
      .catch(() => {
        dispatch(alertActions.error(
          `Could not get ${participant.firstName} ${participant.lastName}'s attention at this time. Please try again later.`
        ))
      })
      .then(() => {
        setGettingAttention(false)
      })
  }

  const attentionBtn = classNames('fas fa-concierge-bell fa-xs p-1', {
    'disabled axs-shake': gettingAttention
  })

  return <div>
    {licensedUser &&
      <RenderProfile
        name={`${licensedUser.firstName} ${licensedUser.lastName}`}
        type={ conversation.location ? conversation.location.name : '' }
        cached={false}
        profileUrl={licensedUser.profileUrl}
      />
    }

    {staffUser &&
      <RenderProfile
        name={`${staffUser.firstName} ${staffUser.lastName}`}
        type={staffUser.type}
        cached={false}
        profileUrl={staffUser.profileUrl}
      />
    }

    <br />

    <div className="row my-4">
      <div className="col">
        <h3 className='m-0 font-weight-light'>Participants</h3>
      </div>
    </div>

    {participant &&
      <div className="row">
        <div className='col'>
          <Participant
            name="Yourself"
            profileUrl={participant.profile}
            lastReadAt={participant.lastReadAt}
            hasMessages={true}
            notifications={participant.notifications}
          />
        </div>
      </div>
    }

    {participants.map((participant, i) => {
      return <div className="row" key={i}>
        <div className='col'>
          <Participant
            name={`${participant.firstName} ${participant.lastName}`}
            profileUrl={participant.profile}
            lastReadAt={participant.lastReadAt}
            hasMessages={true}
            notifications={participant.notifications}
          >
            <div className="col-2 my-auto">
              {!participant.notifications &&
                <OverlayTrigger
                  placement='top'
                  overlay={
                    <Popover>
                      <Popover.Content>
                        By ringing the bell, an email will be sent to get {participant.firstName} {participant.lastName}'s attention.
                      </Popover.Content>
                    </Popover>
                  }
                >
                  <button className="btn btn-sm p-1 btn-outline-primary"><i onClick={() => handleGetParticipantAttention(participant)} className={attentionBtn}></i></button>
                </OverlayTrigger>
              }
            </div>
          </Participant>
        </div>
      </div>
    })}


    {conversation && conversation.status === 'open' &&
      <div className="form-group">
        <br />

        <ParticipantSearch
          removeCurrentUser={true}
          participant={selectedParticipant}
          placeholder='Add Participant'
          handleSelected={(participant, fullParticipant) => {
            setShowConfirmModal(true)
            setSelectedParticipant(fullParticipant)
          }}
        />

        <ConfirmModal
          show={showConfirmModal}
          error={participantError}
          adding={addingParticipant}
          participant={selectedParticipant}
          shouldNotify={shouldNotify}
          isParticipant={participant}
          handleCancel={handleCloseConfirm}
          handleConfirm={handleConfirmParticipant}
        />
      </div>
    }
  </div>
}